import baseUrl from "../config/baseUrl";

const viewDocumentsBulkLink = async ({ token, docIds }) => {
  try {
    const response = await fetch(`${baseUrl}/api/view-documents-bulk-link`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ document_ids: docIds }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default viewDocumentsBulkLink;
